'use client';

import { ViewportPreviewVideo } from '@/components/ui/ViewportPreviewVideo';
import { LazyImage } from '@/components/ui/LazyImage';
import { cn } from '@/lib/cn';
import { getCardVideoPreview } from '@/lib/card-video-preview';

const VIDEO_COVER_PATTERN = /\.(?:mp4|mov|webm|m4v)(?:[?#].*)?$/i;

export function isComposerSkillVideoCover(url: string): boolean {
  return VIDEO_COVER_PATTERN.test(url.trim());
}

export function ComposerSkillCoverMedia({
  src,
  alt,
  className,
  mediaClassName,
  mediaType,
  loading = 'lazy',
  onError,
}: {
  src: string;
  alt: string;
  className?: string;
  mediaClassName?: string;
  mediaType?: 'image' | 'video';
  loading?: 'lazy' | 'eager';
  onError?: () => void;
}) {
  if (mediaType === 'video' || (mediaType !== 'image' && isComposerSkillVideoCover(src))) {
    const preview = getCardVideoPreview(src);
    return (
      <ViewportPreviewVideo
        src={preview?.src ?? src}
        poster={preview?.poster}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
        className={cn('h-full w-full object-cover', className, mediaClassName)}
        onError={onError}
        data-composer-skill-cover-video
      />
    );
  }

  return (
    <LazyImage
      src={src}
      alt={alt}
      aspectClass=""
      className={cn('h-full w-full', className)}
      imgClassName={cn('h-full w-full object-cover', mediaClassName)}
      loading={loading}
      fallbackNode={onError ? null : undefined}
      onError={onError}
    />
  );
}
